var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgW3Html5Ar21(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 60,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.3 21.475H12v5.63h5.213v-5.63h5.7v17.05h-5.7v-5.7H12v5.7H6.3v-17.05zm24.107 5.655H25.38v-5.654h15.736v5.654h-5.02v11.397h-5.7V27.13zm13.207-5.655h5.943l3.656 6 3.652-6H62.8v17.05h-5.676v-8.452l-3.92 6.063h-.098L49.2 30.074v8.452h-5.576zm22.03 0h5.7V32.9h8.015v5.636H65.645z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M82.07 12.06h31.637l-2.882 32.288L97.87 47.94l-12.92-3.587z",
    fill: "#e44d26"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M108.36 42.293l2.463-27.592H97.9v30.494z",
    fill: "#f16529"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M92.65 26.678l-.362-4.056H97.9v-3.96h-9.93l1.068 11.977H97.9v-3.96zm-3.446 5.942l.555 6.22 8.113 2.252.018-.005v-4.12l-.017.005-4.4-1.2-.282-3.16h-2.143z",
    fill: "#ebebeb"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M106.986 27.74l.097-1.064h-9.206v3.96h4.877l-.46 5.137-4.417 1.192v4.12l8.12-2.25.06-.67zm-9.1-5.118h9.567l.355-3.97h-9.922v3.95z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgW3Html5Ar21);
export default __webpack_public_path__ + "static/media/w3_html5-ar21.d1add168bfad0343225307ffd57710dd.svg";
export { ForwardRef as ReactComponent };